<template>
  <div class="home">
    <img :src="comData.connectPicBackground || homeBackground" alt="" mode="widthFix">
    <div class="music-box">
      <img src="https://img3.quanyou.com.cn/joy/group1/M00/14/F9/rB4ChWL6Do2AMIn1AAAFj6TyvdU119.png" alt="" v-if="isPlay" @click="play">
      <img src="https://img3.quanyou.com.cn/joy/group1/M00/14/F8/rB4ChmL6D42AQHksAAAFCjQ7euo129.png" alt="" v-else @click="play">
    </div>
    <div class="right">
      <img src="https://img3.quanyou.com.cn/joy/group1/M00/17/4F/rB4ChWM2Xw2AHEWkAAA1qmjNrOI003.png" alt="">
      <img src="https://img3.quanyou.com.cn/joy/group1/M00/17/4F/rB4ChWM2XsWALRYvAAA8XA3IRek368.png" alt="" v-if="isLottery">
    </div>
    <div class="button-box">
      <img src="https://img3.quanyou.com.cn/joy/group1/M00/17/4F/rB4ChWM2X1OAEtUpAACVn1F9u-I436.png" alt="" @click="to('/connect-pic')">
    </div>
    
    <div class="text">
      已有118人参与活动 <br/> 您今天还有5次参与机会 
    </div>
    <audio ref="audio" preload="auto" loop id="audio" :src="comData.backgroundMusic"></audio>
  </div>
</template>

<script>
export default {
  props: {
    isLottery: {
      type: Boolean,
      default: false
    },
    comData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      homeBackground: 'https://img3.quanyou.com.cn/joy/group1/M00/17/51/rB4ChWM2eK2AOGAFAArmhM2si8c128.png',
      isMusic: false,
      oAudio: null,
      isPlay: false,
    }
  },
  computed: {
    isPreivew() {
      return this.$route.query.isPreview == 1;
    },
    // 组件创建方式
    isNewCreationMode() {
      return this.$route.query.creationMode == 'new'
    }
  },
  methods: {
    to(path) {
      if (this.isNewCreationMode) return 
      this.comData.isPreivew = this.isPreivew
      this.$router.push({path,query:this.comData})
    },
    onCancel() {
      this.isMusic = false
    },
    play() {
      if (this.comData.backgroundMusic) {
        this.isPlay = !this.isPlay
        if (this.isPlay) {
          this.getMusic()
        }else {
          this.oAudio.pause()
        }
      }else {
        this.$toast('暂无音乐')
      }
    },
    getMusic() {
      document.addEventListener('touchstart',this.audioAutoPlay,false);
      document.addEventListener('WeixinJSBridgeReady', this.audioAutoPlay,false);
      this.oAudio = document.querySelector("#audio");
      this.oAudio.load();
      this.oAudio.play();
    }
  }
}
</script>

<style lang="stylus" scoped>
  .home {
    position: relative
    height 100%
    overflow hidden
    font-size 0
    img {
      width 100%
      height auto
    }
    .music-box {
      top: 32px;
      position: absolute;
      right: 12px;
      img {
        width 28px;
        height: 28px;
      }
    }
    .right {
      position: absolute;
      top: 124px;
      right: 10px;
      img {
        display: block;
        width: 60px;
        height: 60px;
        margin-bottom: 10px;
      }
    }
    .button-box {
        position:absolute;
        bottom: 62px;
        left:50%;
        transform: translateX(-50%);
      img {
        width: 185px;
        height: 75px;
        margin-bottom: 10px;
      }
    }
    .text {
      position: absolute;
      bottom: 33px;
      left: 50%;
      margin-left: -57px;
      width: 130px;
      text-align: center;
      font-size: 10px;
      font-weight: 500;
      color: #A4D6A6;
    }
  }
 
</style>